import { SET_LAYER_MODAL_ACTIVE } from '../../constants/appTypes';

const initialState: {
  active: boolean;
  layerTitle: string | null;
  deleteLayer: boolean;
} = {
  active: false,
  layerTitle: null,
  deleteLayer: false,
};

interface layerModalAction {
  active: boolean;
  layerTitle: string | null;
  deleteLayer: boolean | null;
  type: string;
}

export function layerModal(state = initialState, action: layerModalAction) {
  switch (action.type) {
    case SET_LAYER_MODAL_ACTIVE:
      return {
        active: action.active,
        layerTitle: action.layerTitle,
        deleteLayer: action.deleteLayer ? action.deleteLayer : false,
      };
    default:
      return state;
  }
}

export default layerModal;
